import React from "react";
import CommonNudge from "./CommonNudge";

const parseNudge = (data) => {
  try {
    const parsed = typeof data === "string" ? JSON.parse(data) : data;
    return Array.isArray(parsed) ? parsed[0] : parsed;
  } catch {
    return null;
  }
};

const ChatApiNudge = ({ item, handleClick, disable, onClose }) => {
  const nudge = parseNudge(item?.data);

  if (!nudge || nudge?.shown === false) return null;

  const handleAction = () => {
    if (disable) return;

    onClose?.();
    handleClick?.(
      item?.code || nudge?.nodeId,
      nudge?.flow,
      nudge?.flow,
      nudge?.flow
    );
  };

  return (
    <CommonNudge
      title={nudge?.context}
      description={
        nudge?.text ? (
          <span dangerouslySetInnerHTML={{ __html: nudge.text }} />
        ) : null
      }
      actionLabel={nudge?.flow}
      onAction={handleAction}
      onClose={onClose}
      disabled={disable}
      ariaLabel={nudge?.nudgeType || "Chat notification"}
      dockToBottom
    />
  );
};

export default ChatApiNudge;
